module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gb-eng-ee3571430d489c32deaca52df1c49f09.svg";